import React from "react";
import { Switch, Route } from 'react-router-dom';
import HttpHelper from "../../helper/http-helper";
import Config from "../../config/config";
import { Spin } from "antd";
import App from "./app";
import TplEditor from "../tpl/tpl-editor";

import "./manage.scss";


export default class Manage extends React.PureComponent<{}, any> {
    constructor(props: any) {
        super(props);
        this.state = { isLoading: true, isTpl: false };
    }

    componentDidMount() {
        let username = '';
        let token = '';

        try {
            const str = localStorage.getItem('token') || '{}';
            const obj = JSON.parse(str) || { username: '', token: '' };
            username = obj.username;
            token = obj.token;
        } catch (e) {
            console.warn(e);
        }

        if (username === '' || token === '') {
            return;
        }

        HttpHelper.get('/passport/status', {}, { 'Authorization': token }).then((res) => {
            Config.username = res.data.username;
            Config.token = res.data.token;
            localStorage['token'] = JSON.stringify(res.data);
            HttpHelper.addToken(Config.token);

            this.setState({ isLoading: false });
        }).catch(err => {
            console.warn(err);
            // message.error(err.message || '获取状态错误');
            // @ts-ignore
            this.props.history.push('/passport/login');
        });

        this.setState({ isTpl: window.location.href.indexOf('tpl/editor') > 0 });
    }

    public render() {
        const { isLoading, isTpl } = this.state;
        return <>
            {isLoading ?
                <div className="screen">
                    <div className="center"><Spin fullscreen tip='加载中...' spinning={this.state.isLoading} size="large"></Spin></div>
                </div>
                : null}

            {!isLoading && isTpl ?
                <Switch>
                    <Route path="/manage/tpl/editor/:uuid" component={TplEditor} />
                </Switch>
                : null}

            {!isLoading && !isTpl ? <App {...this.props} /> : null}
        </>;
    }
}